import { appData } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-950">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-5">
              {appData.title}
            </h2>
            <p className="text-background-400 text-sm md:text-base leading-relaxed max-w-lg mx-auto lg:mx-0 mb-8">
              {appData.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <button className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm whitespace-nowrap transition-colors cursor-pointer">
                <i className="ri-smartphone-line text-lg"></i>
                手机端体验
              </button>
              <button className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg border border-background-700 hover:border-background-500 text-background-300 hover:text-background-100 font-medium text-sm whitespace-nowrap transition-all cursor-pointer">
                <i className="ri-bookmark-line text-lg"></i>
                收藏本站
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[450px]">
            <div className="relative">
              <div className="absolute -inset-6 bg-gradient-to-r from-primary-500/15 via-accent-500/10 to-primary-500/15 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20movie%20streaming%20app%20interface%20with%20film%20posters%20and%20categories%2C%20dark%20cinematic%20UI%20design%2C%20warm%20accent%20colors%2C%20modern%20minimal%20layout%2C%20isolated%20on%20dark%20background&width=500&height=400&seq=app-mockup-01&orientation=portrait"
                alt="春色影视手机端展示"
                className="relative w-full max-w-[300px] mx-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}